import { gameInstance } from '@Game/GameComponent';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { TStateResolver } from '@Managers/StateMachine/StateMachine.types';
import { EWildWheelFeatureStates } from './WildWheelFeatureStates';

export const wildWheelResultResolver: TStateResolver<EWildWheelFeatureStates> = () => {
    const { merge } = gameInstance.gameStore.get(EGameStoreKeys.WildWheelConfiguration);
    const visibleSymbols = gameInstance.gameStore.get(EGameStoreKeys.VisibleSymbols);
    const wilds = [];
    for (const reel of visibleSymbols) {
        for (const symbol of reel) {
            if (symbol.isWild()) wilds.push(symbol);
        }
    }

    if (merge?.spineName && wilds.length > 1) return EWildWheelFeatureStates.WILD_WHEEL_MERGE_START;
    return EWildWheelFeatureStates.WILD_WHEEL_END;
};

export const wildWheelEndResolver: TStateResolver<EWildWheelFeatureStates> = () => {
    return EWildWheelFeatureStates.WILD_WHEEL_HIDDEN;
};

export const wildWheelMergeEndResolver: TStateResolver<EWildWheelFeatureStates> = () => {
    return EWildWheelFeatureStates.WILD_WHEEL_HIDDEN;
};
